import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { setLanguage } from "../utils/api";

import dayjs from "dayjs";
import "dayjs/locale/it";
import "dayjs/locale/en";
import "dayjs/locale/fr";
import "dayjs/locale/de";
import "dayjs/locale/es";
import "dayjs/locale/ru";
import "dayjs/locale/zh-cn";

const LanguageSelector = () => {
  const ref = useRef(null);
  const { i18n } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  const languages = [
    { code: "it", label: "Italiano" },
    { code: "en", label: "English" },
    { code: "fr", label: "Français" },
    { code: "de", label: "Deutsch" },
    { code: "es", label: "Español" },
    { code: "ru", label: "Русский" },
    { code: "zh", label: "中文" },
  ];

  const handleLanguageChange = (code) => {
    // Set the language in i18n
    i18n.changeLanguage(code);

    // Set the language in dayjs
    dayjs.locale(code);

    // Set the language in the API
    setLanguage(code);
    setExpanded(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setExpanded(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  });

  return (
    <div className={`language-selector${expanded ? " selector--expanded" : ""}`} ref={ref}>
      <div
        className="language-selector__selected"
        onClick={() => setExpanded(!expanded)}
      >
        {languages.find((language) => language.code === i18n.language)?.label}
      </div>
      <div className="language-selector__list">
        {languages.map((language) => (
          <div
            key={language.code}
            className={`language-selector__item ${language.code === i18n.language ? "language-selector__item--active" : ""}`}
            onClick={() => handleLanguageChange(language.code)}
          >
            {language.label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default LanguageSelector;
